import React from "react"
import types from "prop-types"
import { withFormsy } from "formsy-react"
import clsx from "clsx"

const RadioButton = ({
  className = "",
  id = "",
  label = "",
  name = "",
  value,
  checked,
  onChange,
  disabled = false,
}) => {
  const cursorClass = disabled ? "cursor-not-allowed" : "cursor-pointer"

  // If an id is passed to the radio button, use it as the input's id.
  // If no id is passed, build one from the name prop.
  const inputId = id || `${name}-${value}-radio-button`

  return (
    <div
      className={clsx(className, cursorClass, "flex gap-2 items-center")}
      onClickCapture={() => !disabled && onChange(value)}
    >
      <input
        type="radio"
        className={cursorClass}
        id={inputId}
        name={name}
        disabled={disabled}
        value={value}
        checked={checked}
        onChange={(event) => onChange(event.target.value)}
      />
      <label className={cursorClass} htmlFor={inputId}>{ label || value }</label>
    </div>
  )
}

RadioButton.propTypes = {
  name: types.string,
  className: types.string,
  id: types.string,
  label: types.string,
  value: types.string.isRequired,
  checked: types.bool.isRequired,
  onChange: types.func.isRequired,
  disabled: types.bool,
}

export const FormsyRadioButton = withFormsy(({ setValue, ...rest }) => (
  <RadioButton
    onChange={setValue}
    {...rest}
  />
))

export default RadioButton
